import { useContext, useEffect } from "react";
import { AppContext } from "../App";
import { t } from "../i18n";

export const ErrorPage = () => {
	const { isTransitioning } = useContext(AppContext);

	useEffect(() => {
		setTimeout(() => {
			sessionStorage.removeItem("Data");
		}, 100);
	}, []);

	return (
		<div
			className={
				"content content_error_page kensei_03" +
				(isTransitioning ? " fade-in" : "")
			}
		>
			<h2 className="error_page_taller_h2">{t("¡Lo sentimos!")}</h2>
			<p className="error_page_taller_p">
				{t("Se ha producido un error en el proceso de tu reserva.")}
			</p>
			<p className="error_page_taller_p">
				{t(
					"Alguien de nuestro equipo se pondrá en contacto contigo para confirmar los detalles de tu reserva."
				)}
			</p>
		</div>
	);
};
